export const StorageIsNotEnabled = {
  title:
    'WARNING: Storage is not enabled. Please enable the storage from the Hosting Service Configuration.',
  type: 'warning',
} as const;

export const StorageErrorDeleting =
  'An error ocurred during disabling the storage account. Check out the logs.';

export const StorageErrorCreating =
  'An error ocurred during creating the storage account. Check out the logs.';

export const GenerationRequiredParametersAreNotDefined = {
  title:
    'Credentials can not be regenerated. Required request parameters are not initialized. Contact your administrator.',
  type: 'warning',
} as const;

export const CredentialsCanNotBeRegenerated = {
  title:
    'Credentials can not be regenerated. Cloud provider respond with empty value. Contact your administrator.',
  type: 'warning',
} as const;

export const SaveConnectionValueSecurely = {
  title:
    'Please copy the connection string displayed below and store it in a secure location.',
  type: 'warning',
} as const;
